import * as React from 'react';
import { icons, ns } from 'solid-ui';
import { createElement } from './dom';
import { Pane } from './Pane';
const thisPane = {
    global: false,
    icon: icons.iconBase + 'noun_15695.svg',
    name: 'activitystreams',
    label: function (subject, context) {
        const t = context.session.store.findTypeURIs(subject);
        if (t[ns.as('Note').uri]) {
            return 'Note';
        }
        return null;
    },
    render: (subject, context) => {
        return createElement(React.createElement(Pane, { subject: subject, context: context }));
    },
};
export default thisPane;
//# sourceMappingURL=index.js.map